import { render, staticRenderFns } from "./bindChoice.vue?vue&type=template&id=5c2e2794&scoped=true&"
import script from "./bindChoice.vue?vue&type=script&lang=js&"
export * from "./bindChoice.vue?vue&type=script&lang=js&"
import style0 from "./bindChoice.vue?vue&type=style&index=0&id=5c2e2794&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e2794",
  null
  
)

export default component.exports